import React from "react";
import { argoBaseUri } from "./env";

export default function argoLink(
  argoWorkflowId: string | null,
  target: string = "_blank"
): JSX.Element {
  let link = <a>n/a</a>;
  if (argoWorkflowId) {
    link = (
      <a href={`${argoBaseUri}${argoWorkflowId}`} target={target}>
        {argoWorkflowId}
      </a>
    );
  }
  return link;
}
